import { tripTypeSelector, pageMakerSelector, oneWayCabSelector } from './../../../common/redux/selector';
import {createSelector} from 'reselect';
import { AppState } from '../../../../store';
export const HomeSelector = (state: AppState) => state.home;
export const offerSelector = createSelector(HomeSelector, item => item.offers || []);
export const templateSelector = createSelector(HomeSelector, item => item.template || {});
export const tripTypeTemplatedata = createSelector([pageMakerSelector, tripTypeSelector, oneWayCabSelector], (pageMaker, trip, isOneWayCab) => {
  const item = pageMaker['cabs_dweb_home_data'] || {};
  let data = {};
  switch (trip.rf) {
    case 'ow':
      data = isOneWayCab ? item['one-way-cab'] : item['one-way'];
      break;
    case 'rt':
      data = item['round-trip'];
      break;
    case 'at':
      data = item['airport'];
      break;
    case 'hr':
      data = item['rental'];
      break;
    default:
      data = item['round-trip'];
      break;
  }
  return data || {};
});

export const persuasionSelector = createSelector(tripTypeTemplatedata, item => item?.persuasions || []);
export const faqSelector = createSelector(tripTypeTemplatedata, item => item?.faq || []);
export const popularRoutesSelector = createSelector(tripTypeTemplatedata, item => item?.popular_routes || []);
export const topCarouselSelector = createSelector(tripTypeTemplatedata, item => item?.top_carousel || []);
export const popularSearchSelector = createSelector(tripTypeTemplatedata, item => item?.popular_searches || []);
export const contentSelector = createSelector(tripTypeTemplatedata, item => item?.content || '')
export const travellerDetailsCalledSelector = createSelector(HomeSelector, item => item.travellerDetailsCalled || false);